import { useStore } from 'effector-react'
import {
  $exchangers,
  $totalCountOfExchangers,
  exchangerListMounted,
  getExchangers,
} from './model'
import { ExchangersRequest } from './types'

export const useExchangerList = () => {
  const exchangers = useStore($exchangers)

  const loading = useStore(getExchangers.pending)

  const totalCountOfExchangers = useStore($totalCountOfExchangers)

  const onChangeExchangerList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    dateFilter,
    filters,
  }: ExchangersRequest) => {
    exchangerListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      dateFilter,
      searchText,
      filters,
    })
  }

  return { exchangers, totalCountOfExchangers, loading, onChangeExchangerList }
}
